import { render, staticRenderFns } from "./Wallets.html?vue&type=template&id=05273732&external"
import script from "./Wallets.js?vue&type=script&lang=js&external"
export * from "./Wallets.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports